/*
* Created on Feb 03, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/

export const ActivityCategory = [
    '@Account@',
    '@Organization@',
    '@Group@',
    '@Site@',
    '@Device@',
    '@Cloud Space@'
]


export const ActivityEvent = [
    'create_organization',
    'update_organization',
    'delete_organization',
    'create_group',
    'update_group',
    'delete_group',
    'invite_org_admin',
    'update_org_user',
    'remove_org_user',
    'set_owner',
    'unset_owner',
    'remove_user_from_gorup',
    'add_users_to_group',
    'add_org_site',
    'remove_org_site',
    'update_org_site',
    'add_site_admin',
    'remove_site_admin',
    'transfer_device'
]

export const LOG_EVENT_MAPPING = {
    add: [1, 4, 7, 14, 17, 22, 25],
    remove: [3, 6, 9, 12, 15, 18, 23, 26],
    edit: [2, 5, 8, 10, 11, 13, 16, 19, 24, 27, 28, 30],
    transfer: [20]
}